import React from 'react';
import './FancyRectangle.css';

const FancyRectangle = ({ children }) => {
  return <div className="fancy-rectangle">{children}</div>;
};

export default FancyRectangle;
